module.exports = __webpack_public_path__ + "static/media/sgd.7fa94b0a.svg";